import React from 'react';

const Dashboard = () => {
  return (
    <div className="container">
      <h1>Dashboard</h1>
      <p>Welcome to your dashboard!</p>
    </div>
  );
};

export default Dashboard;
